import { Routes, Route } from 'react-router-dom';
import './App.scss';
import Layout from './components/Layout';
import Home from './components/Home';
import About from './components/About';
import Buyers from './components/Buyers';
import Owners from './components/Owners';
import Contact from './components/Contact';

function App() {
  return (
    <>
  <Routes>
    <Route path="/" element={<Layout />}>
    <Route index element={<Home />} />
    <Route path="about" element={<About />} />
    <Route path="buyers" element={<Buyers />} />
    <Route path="owners" element={<Owners />} />
    <Route path="contact" element={<Contact />} />
    </Route>
  </Routes>
  </>
    )
}

export default App;



